import { render, staticRenderFns } from "./SrDateRangePicker.vue?vue&type=template&id=8161d070"
import script from "./SrDateRangePicker.vue?vue&type=script&lang=js"
export * from "./SrDateRangePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports